var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"profile"}},[_c('Hero',{attrs:{"title":_vm.$t('views.profile.title')}}),_c('div',{staticClass:"content-wrapper"},[_c('ProfileUpdateForm')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }